import { Component, OnChanges, SimpleChanges, input, output } from '@angular/core';
import { Validators } from '@angular/forms';

import { EditFieldComponent } from '@camelot/form-basic';
import {
  InputDatePicker,
  InputTextBox,
  InputTimePicker,
  TimePickerValue,
  combineDateAndTime,
  extractTimeFromDate,
} from '@camelot/form-model';
import { TranslatePipe } from '@camelot/translation';
import { CamBaseComponent, CamDatePipe, RequestState } from '@camelot/utils';

import { CamTranslationCore } from '../../translation.service';

export enum EDateTimeEditorFields {
  start = 'start',
  end = 'end',
  date = 'date',
}

@Component({
  selector: 'cam-date-time-range-editor',
  imports: [CamDatePipe, EditFieldComponent, TranslatePipe],
  templateUrl: './date-time-range-editor.component.html',
  styleUrl: './date-time-range-editor.component.scss',
})
export class DateTimeRangeEditorComponent extends CamBaseComponent implements OnChanges {
  startDate = input.required<string>();

  endDate = input.required<string>();

  editRequestState = input<RequestState>(new RequestState());

  dateChange = output<{ start: Date; end: Date }>();

  readonly EDateTimeEditorFields = EDateTimeEditorFields;

  public startTime: TimePickerValue = { hours: 0, minutes: 0 };
  public endTime: TimePickerValue = { hours: 0, minutes: 0 };

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['startDate'].previousValue !== changes['startDate'].currentValue) {
      this.startTime = extractTimeFromDate(this.startDate() ?? '');
    }
    if (changes['endDate'].previousValue !== changes['endDate'].currentValue) {
      this.endTime = extractTimeFromDate(this.endDate() ?? '');
    }
  }

  public getFields(fields: EDateTimeEditorFields) {
    switch (fields) {
      case EDateTimeEditorFields.start:
        return () =>
          new InputTimePicker({
            key: EDateTimeEditorFields.start,
            validators: [Validators.required],
            value: this.startTime,
          });
      case EDateTimeEditorFields.end:
        return () =>
          new InputTimePicker({
            key: EDateTimeEditorFields.end,
            value: this.endTime,
            min: this.startTime,
            validators: [Validators.required],
          });
      case EDateTimeEditorFields.date:
        return () =>
          new InputDatePicker({
            key: EDateTimeEditorFields.date,
            value: this.startDate(),
            validators: [Validators.required],
          });
      default:
        return () =>
          new InputTextBox({
            key: 'nokey',
            label: '',
          });
    }
  }

  public emit(value?: any, fields?: EDateTimeEditorFields) {
    switch (fields) {
      case EDateTimeEditorFields.start:
        this.dateChange.emit({
          start: combineDateAndTime(new Date(this.startDate()), value),
          end: new Date(this.endDate()),
        });
        break;
      case EDateTimeEditorFields.end:
        this.dateChange.emit({
          start: new Date(this.startDate()),
          end: combineDateAndTime(new Date(this.startDate()), value),
        });
        break;
      case EDateTimeEditorFields.date:
        this.dateChange.emit({
          start: combineDateAndTime(new Date(value), this.startTime),
          end: combineDateAndTime(new Date(value), this.endTime),
        });
        break;
      default:
        return;
    }
  }
}
